import { autorun } from 'mobx'
import { observer } from 'mobx-react'
import { PropsWithChildren, useEffect } from 'react'
import { useNotificationCenterApi } from '../components/notificationCenter'
import { useOfflinePackageContext } from '../pages/PackageHostPage/PackageListPageContext'
import FormPackageBackgroundSyncService from './offline/FormPackageBackgroundSyncService'
import { SessionService } from './session'

const BackgroundServices = observer((props: PropsWithChildren<unknown>) => {
	const notificationContextApi = useNotificationCenterApi()
	const offlineContext = useOfflinePackageContext()

	useEffect(() => {
		const disposerFunctions: (() => void)[] = []

		autorun(() => {
			const packageSync = new FormPackageBackgroundSyncService(
				notificationContextApi,
				offlineContext,
			)

			const sessionService = SessionService.getInstance()

			if (sessionService.isAuthenticated) {
				packageSync.start().then((v) => {
					disposerFunctions.push(v)
				})
			}
		})

		return () => {
			for (const disposer of disposerFunctions) disposer()
		}
	}, [notificationContextApi])

	return <>{props.children} </>
})

export default BackgroundServices
